<template lang="html">
	<div class="about">
		<TopContent />
		<Activities />
		<!--  <Modules />
      <Partners />
      <Testimonials /> -->
	</div>
</template>

<script>
import about from './about.store';

export default {
	beforeDestroy() {
		this.$store.unregisterModule('about');
	},
	created() {
		utils.registerModule('about', about, this.$store);
	},
	components: {
		TopContent: () => import('./top-content.vue'),
		Activities: () => import('./activities.vue'),
		Modules: () => import('./modules.vue'),
		Partners: () => import('./partners.vue'),
		Testimonials: () => import('../landing/testimonial.vue'),
	},
	computed: {
		...mapGetters(['loading']),
	},
	methods: {
		...mapActions(['fetchData']),
	},
	async mounted() {
		utils.registerModule('about', about, this.$store);
		await this.fetchData();
	},
};
</script>

<style lang="less">
.about {
}
</style>
